import { FIRING_TYPE_LABELS } from './pages';

/** Text rendered into the ImmoScout24 listing body (ADR 0009: property/infrastructure/immoscout24). */
export const portal = {
  commission: {
    rate: '{rate, number, ::.00} % inkl. 19 % USt. vom Kaufpreis, zahlbar durch den Käufer',
    amount: '{amount, number, ::.00} € inkl. 19 % USt., zahlbar durch den Käufer',
    'buyer-free': 'Für den Käufer provisionsfrei',
    'tenant-free': 'Für den Mieter provisionsfrei',
    'figure-rate': '{rate, number, ::.00} % inkl. 19 % USt. vom Kaufpreis',
    'figure-amount': '{amount, number, ::.00} € inkl. 19 % USt.',
  },
  is24: {
    vatNote:
      '{subject, select, SALE {Kaufpreis} other {Miete}} {treatment, select, NET_PLUS_VAT {zzgl.} other {inkl.}} {rate, number} % MwSt.',
    vatNoteWithoutRate:
      '{subject, select, SALE {Kaufpreis} other {Miete}} {treatment, select, NET_PLUS_VAT {zzgl.} other {inkl.}} MwSt.',
    netPurchasePrice: 'Nettokaufpreis: {amount, number, ::currency/EUR}.',
    depositAmount: '{amount, number, ::currency/EUR}',
    depositMonths: '{months, plural, one {# Nettokaltmiete} other {# Nettokaltmieten}}',
  },
  energyParagraph: {
    lead: 'Energieausweis:',
    basis: { DEMAND: 'Bedarfsausweis', CONSUMPTION: 'Verbrauchsausweis' },
    'issued-at': 'ausgestellt am {date}',
    'primary-energy-value': 'Primärenergiebedarf {value} kWh/(m²·a)',
    'energy-class': 'Energieeffizienzklasse {energyClass}',
    'year-built': 'Baujahr {year}',
    'energy-source': 'wesentlicher Energieträger {source}',
    'firing-type': FIRING_TYPE_LABELS,
  },
  openimmo: {
    salutation: { MR: 'Herr', MRS: 'Frau' },
    facts: {
      constructionPhase: 'Bauphase: {value}',
      buildingPermission: 'Baugenehmigung: {permitted, select, true {liegt vor} other {liegt nicht vor}}',
      shortTermBuildable: 'Kurzfristig bebaubar',
      demolition: 'Abriss erforderlich',
      rentFreeMonths: 'Mietfreie Zeit: {months, plural, one {# Monat} other {# Monate}}',
      fitOutContribution: 'Baukostenzuschuss: {amount, number, ::currency/EUR}',
      renewalOption: 'Verlängerungsoption: {value}',
      subletting: 'Untervermietung: {value}',
      rentType: 'Mietart: {value}',
    },
    constructionPhase: { PROJECTED: 'Projektiert', UNDER_CONSTRUCTION: 'Im Bau', COMPLETED: 'Fertiggestellt' },
    subletting: { ALLOWED: 'erlaubt', NOT_ALLOWED: 'nicht erlaubt', ON_REQUEST: 'auf Anfrage' },
    rentType: { FIXED: 'Festmiete', GRADUATED: 'Staffelmiete', INDEXED: 'Indexmiete' },
    energySource: {
      NATURAL_GAS_LIGHT: 'Erdgas leicht',
      NATURAL_GAS_HEAVY: 'Erdgas schwer',
      DISTRICT_STEAM: 'Fernwärme-Dampf',
      LOCAL_HEAT: 'Nahwärme',
      HEAT_DELIVERY: 'Wärmelieferung',
      BIOENERGY: 'Bioenergie',
      WIND_ENERGY: 'Windenergie',
      WATER_ENERGY: 'Wasserenergie',
      ENVIRONMENTAL_HEAT: 'Umweltwärme',
    },
  },
} as const;
